import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  AreaOfConcernDisputeDocumentDto,
  AreaOfConcernDto,
  CreateUpdateAreaOfConcernDocumentDto,
  CreateUpdateAreaOfConcernDto,
} from "../../models/dispute-resolution/area-of-concern-models";

@Injectable({
  providedIn: "root",
})
export class AreaOfConcernService {
  private readonly baseUrl = "/api/dispute-resolution/area-of-concern";
  private readonly documentBaseUrl = `${this.baseUrl}/documents`;

  constructor(private http: HttpClient) { }

  create(request: CreateUpdateAreaOfConcernDto): Observable<AreaOfConcernDto> {
    return this.http.post<AreaOfConcernDto>(`${this.baseUrl}`, request);
  }

  getById(id: string): Observable<AreaOfConcernDto> {
    return this.http.get<AreaOfConcernDto>(`${this.baseUrl}/${id}`);
  }

  update(id: string, request: CreateUpdateAreaOfConcernDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getAll(): Observable<AreaOfConcernDto[]> {
    return this.http.get<AreaOfConcernDto[]>(`${this.baseUrl}`);
  }

  generateCaseNumber(): Observable<string> {
    return this.http.get(`${this.baseUrl}/generate-case-number`, {
      responseType: "text",
    });
  }

  updateCaseStatus(
    disputeCaseId: string,
    workflowStatusChangesId: string
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-case-status/${disputeCaseId}/${workflowStatusChangesId}`,
      null
    );
  }

  createDocument(
    request: CreateUpdateAreaOfConcernDocumentDto
  ): Observable<AreaOfConcernDisputeDocumentDto> {
    return this.http.post<AreaOfConcernDisputeDocumentDto>(
      `${this.documentBaseUrl}`,
      request
    );
  }

  getDocumentsByDisputeCase(
    disputeCaseId: string
  ): Observable<AreaOfConcernDisputeDocumentDto[]> {
    return this.http.get<AreaOfConcernDisputeDocumentDto[]>(
      `${this.documentBaseUrl}/case/${disputeCaseId}`
    );
  }

  deleteDocument(id: string): Observable<void> {
    return this.http.delete<void>(`${this.documentBaseUrl}/${id}`);
  }
}
